// extracted by mini-css-extract-plugin
module.exports = {"list":"AdministrationTabs_list__3Lqh0","list__link":"AdministrationTabs_list__link__WOx-z"};